import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Sin ejemplos argentinos',
    costo: 'Alumnos desconectados que no entienden por qué la minería argentina importa en el mundo'
  }, {
    sin: 'Sin banco de actividades',
    costo: 'Horas semanales perdidas armando material de cero'
  }, {
    sin: 'Sin casos de estudio equilibrados',
    costo: 'Debates minería-ambiente sin fundamento técnico real'
  }, {
    sin: 'Sin banco de evaluaciones',
    costo: 'Evaluaciones repetidas que no miden lo que importa'
  }, {
    sin: 'Sin infografías y recursos visuales',
    costo: 'Esquemas dibujados a mano que no transmiten la escala real'
  }, {
    sin: 'Sin conexión con la actualidad',
    costo: 'Alumnos que no saben que Josemaría es histórico para Argentina'
  }, {
    sin: 'Sin planificaciones listas',
    costo: 'Horas de diseño que podrían dedicarse a enseñar'
  }];
  return <section className="py-20 bg-base text-forest-dark" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="md:text-4xl font-extrabold mb-4 text-[20px]" data-id="element-49">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-muted uppercase text-sm tracking-wider" data-id="element-53">
                ❌ Sin el Megapack
              </div>
              <div className="font-bold text-red-600 uppercase text-sm tracking-wider" data-id="element-54">
                💸 Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-white rounded-xl p-4 items-center border border-sand" data-id="element-56">
                  <div className="text-muted font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-700 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-muted/70 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-white rounded-2xl p-8 md:p-12 shadow-2xl border border-sand" data-id="element-60">
          <p className="md:text-2xl font-medium text-forest mb-4 text-[18px]" data-id="element-61">
            "La próxima vez que un alumno pregunte para qué sirve estudiar
            minería, podés mostrarle que Argentina tiene el segundo mayor
            reservorio de litio del mundo, que hay proyectos de miles de
            millones de dólares en construcción en San Juan, y que el litio
            argentino termina en las baterías de los autos eléctricos de todo el
            planeta. O podés seguir explicando sin ese contexto."
          </p>
          <p className="md:text-4xl font-black text-forest-dark text-[20px]" data-id="element-62">
            🇦🇷⛏️
          </p>
        </motion.div>
      </div>
    </section>;
}